module.exports = __webpack_public_path__ + "media/images/avatar_male3-b5e63dd3d477a20c5ef3894f4c069469.png";